import { Button, Tooltip } from "antd";
import useActionDialogRefine from "hook/bailiff/dialog/useActionDialog";
import React from "react";
import { IoPlaySkipBackOutline } from "react-icons/io5";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const ButtonPrev = () => {
  // -------------------------- VAR -----------------------------
  const { handlePrevDialog } = useActionDialogRefine();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Tooltip title="Nhảy về đoạn trước đó">
      <Button
        onClick={handlePrevDialog}
        type="text"
        size="large"
        icon={<IoPlaySkipBackOutline />}
      />
    </Tooltip>
  );
};
export default ButtonPrev;
